import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import { useGetBlockingDomainActivitiesQuery, useLazyGetBlockingDomainActivitiesQuery } from '../../redux/apis/blockingDomainsManagement/bDActivitiesApiSlice'
import CreateBlockingDomainActivity from '../../components/BlockingDomains/CreateBlockingDomainActivity'
import SearchAndFilterBar from '../../components/other/search/SearchAndFilterBar'
import CountriesDropdown from '../../components/CountriesDropdown'
import CustomersDropdown from '../../components/CustomersDropdown'
import DownloadAllDataButton from '../../components/other/DownloadAllDataButton'
import { can } from '../../helpers/auth'

const BlockingDomainActivity = React.memo(() => {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 })
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  const context = useContext(AppSettings)
  const { data, isLoading, error, isFetching } =
    useGetBlockingDomainActivitiesQuery({
      expand: [
        'created_by',
        'last_updated_by',
        'domain',
        'domain_category',
        'customer',
        'country'
      ].join(','),
      page: pagination.current,
      page_size: pagination.pageSize,
      ...(search ? { search } : {}),
      ...filters
    })

  const [create, setCreate] = useState(false)

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'Customer',
      dataIndex: 'customer',
      key: 'customer',
      filter: true,
      filterComponent: CustomersDropdown,
      render: text => <div>{text?.customer_name}</div>
    },
    {
      title: 'Blocking Country',
      dataIndex: 'country',
      key: 'country',
      filter: true,
      filterComponent: CountriesDropdown,
      render: text => <div>{text?.country_name}</div>
    },
    {
      title: 'Report/Block Date',
      dataIndex: 'report_date',
      key: 'report_date',
      filter: true,
      filterType: 'date'
    },
    {
      title: 'Domain',
      dataIndex: 'domain',
      key: 'domain',
      // filter: true,
      // filterType: 'text',
      render: text => <div>{text?.domain}</div>
    },
    {
      title: 'Category',
      dataIndex: 'domain_category',
      key: 'domain_category',
      // filter: true,
      // filterType: 'text',
      render: text => <div>{text?.category_name}</div>
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      filter: true,
      filterType: 'select',
      filterOptions: [
        { label: 'Blocked', value: true },
        { label: 'UnBlocked', value: false }
      ],
      render: text => <div>{text ? 'Blocked' : 'UnBlocked'}</div>
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',

    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      render: text => (
        <div>
          {text?.first_name} {text?.last_name}
        </div>
      )
    },
    {
      title: 'Updated By',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: text => (
        <div>
          {text?.first_name} {text?.last_name}
        </div>
      )
    }
  ]

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />
      {can('add_blockingdomainactivity') && create && (
        <CreateBlockingDomainActivity open={create} setOpen={setCreate} />
      )}

      <div className='flex'>
        <SearchAndFilterBar
          columns={columns}
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setPagination={setPagination}
        />
        <div className='ml-auto flex gap-4'>
          <DownloadAllDataButton
            lazyQueryHook={useLazyGetBlockingDomainActivitiesQuery}
            fileName='blocking-domains-activity'
          />

          {can('add_blockingdomainactivity') && (
            <button
              className='btn btn-outline-theme ml-auto mb-4'
              onClick={() => setCreate(true)}
            >
              Create New Blocking Domain Activity
            </button>
          )}
        </div>
      </div>

      <div className='row'>
        <ReusableTable
          columns={columns}
          data={data?.data?.results}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.count,
            showSizeChanger: true
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
})

export default BlockingDomainActivity
